/* eslint-disable jsx-a11y/alt-text */
"use client";

import Image, { type ImageProps } from "next/image";
import type React from "react";

const ClientSideImage: React.FC<ImageProps> = (props) => {
  const { onError, ...rest } = props;

  return (
    <Image
      {...rest}
      onError={(e) => {
        if (onError) {
          onError(e);
        } else {
          e.currentTarget.src = "/placeholder-image.jpg";
          console.error("Failed to load image:", props.src);
        }
      }}
    />
  );
};

export default ClientSideImage;
